module.exports = {
	"elementName": "ObjectSchema",
	"name": "UITiles",
	"containers": [
		{
			"name": "Team",
			"elementName": "Grid",
			"style": {},
			"props": {
				"hAlign": "center",
				"gutter": "2px 2px 2px",
				"flexCells": false,
				"background": {
					"filter": {}
				}
			},
			"boxes": [],
			"containers": [
				{
					"name": "Copy Container",
					"elementName": "Cell",
					"style": {},
					"props": {
						"hAlign": "center",
						"size": "1/1",
						"background": {
							"color": {
								"color": "#ffffff",
								"hsv": {
									"h": 0,
									"s": 0,
									"v": 100
								},
								"alpha": 100
							},
							"size": "cover",
							"filter": {}
						}
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {
								"content": {
									"entityMap": {},
									"blocks": [
										{
											"key": "etakp",
											"text": "TEAM",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 4,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										}
									]
								}
							}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"align": "center",
						"hAlign": "center",
						"flex": false,
						"size": "1/4"
					},
					"boxes": [
						{
							"name": "Icon",
							"elementName": "Core.Icon",
							"style": {
								"transform": {}
							},
							"props": {
								"width": 100,
								"height": 100,
								"icon": "MdAssignmentInd"
							},
							"bindings": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"align": "center",
						"hAlign": "center",
						"flex": false,
						"size": "1/4"
					},
					"boxes": [
						{
							"name": "Icon",
							"elementName": "Core.Icon",
							"style": {
								"transform": {}
							},
							"props": {
								"width": 100,
								"height": 100,
								"icon": "MdAssignmentInd"
							},
							"bindings": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"align": "center",
						"hAlign": "center",
						"flex": false,
						"size": "1/4"
					},
					"boxes": [
						{
							"name": "Icon",
							"elementName": "Core.Icon",
							"style": {
								"transform": {}
							},
							"props": {
								"width": 100,
								"height": 100,
								"icon": "MdAssignmentInd"
							},
							"bindings": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"align": "center",
						"hAlign": "center",
						"flex": false,
						"size": "1/4"
					},
					"boxes": [
						{
							"name": "Icon",
							"elementName": "Core.Icon",
							"style": {
								"transform": {}
							},
							"props": {
								"width": 100,
								"height": 100,
								"icon": "MdAssignmentInd"
							},
							"bindings": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"align": "center",
						"hAlign": "center",
						"flex": false,
						"size": "1/4"
					},
					"boxes": [
						{
							"name": "Icon",
							"elementName": "Core.Icon",
							"style": {
								"transform": {}
							},
							"props": {
								"width": 100,
								"height": 100,
								"icon": "MdAssignmentInd"
							},
							"bindings": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"align": "center",
						"hAlign": "center",
						"flex": false,
						"size": "1/4"
					},
					"boxes": [
						{
							"name": "Icon",
							"elementName": "Core.Icon",
							"style": {
								"transform": {}
							},
							"props": {
								"width": 100,
								"height": 100,
								"icon": "MdAssignmentInd"
							},
							"bindings": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"align": "center",
						"hAlign": "center",
						"flex": false,
						"size": "1/4"
					},
					"boxes": [
						{
							"name": "Icon",
							"elementName": "Core.Icon",
							"style": {
								"transform": {}
							},
							"props": {
								"width": 100,
								"height": 100,
								"icon": "MdAssignmentInd"
							},
							"bindings": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"align": "center",
						"hAlign": "center",
						"flex": false,
						"size": "1/4"
					},
					"boxes": [
						{
							"name": "Icon",
							"elementName": "Core.Icon",
							"style": {
								"transform": {}
							},
							"props": {
								"width": 100,
								"height": 100,
								"icon": "MdAssignmentInd"
							},
							"bindings": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"align": "center",
						"hAlign": "center",
						"flex": false,
						"size": "1/4"
					},
					"boxes": [
						{
							"name": "Icon",
							"elementName": "Core.Icon",
							"style": {
								"transform": {}
							},
							"props": {
								"width": 100,
								"height": 100,
								"icon": "MdAssignmentInd"
							},
							"bindings": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"align": "center",
						"hAlign": "center",
						"flex": false,
						"size": "1/4"
					},
					"boxes": [
						{
							"name": "Icon",
							"elementName": "Core.Icon",
							"style": {
								"transform": {}
							},
							"props": {
								"width": 100,
								"height": 100,
								"icon": "MdAssignmentInd"
							},
							"bindings": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"align": "center",
						"hAlign": "center",
						"flex": false,
						"size": "1/4"
					},
					"boxes": [
						{
							"name": "Icon",
							"elementName": "Core.Icon",
							"style": {
								"transform": {}
							},
							"props": {
								"width": 100,
								"height": 100,
								"icon": "MdAssignmentInd"
							},
							"bindings": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"align": "center",
						"hAlign": "center",
						"flex": false,
						"size": "1/4"
					},
					"boxes": [
						{
							"name": "Icon",
							"elementName": "Core.Icon",
							"style": {
								"transform": {}
							},
							"props": {
								"width": 100,
								"height": 100,
								"icon": "MdAssignmentInd"
							},
							"bindings": {}
						}
					],
					"containers": [],
					"bindings": {}
				}
			],
			"bindings": {}
		},
		{
			"name": "Price",
			"elementName": "Grid",
			"style": {},
			"props": {
				"gutter": "2px 2px 2px",
				"flexCells": false
			},
			"boxes": [],
			"containers": [
				{
					"name": "Copy Container",
					"elementName": "Cell",
					"style": {},
					"props": {
						"hAlign": "center",
						"size": "1/1",
						"background": {
							"color": {
								"color": "#ffffff",
								"hsv": {
									"h": 0,
									"s": 0,
									"v": 100
								},
								"alpha": 100
							},
							"filter": {}
						}
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {
								"content": {
									"entityMap": {},
									"blocks": [
										{
											"key": "1ub67",
											"text": "Price",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 5,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										}
									]
								}
							}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"hAlign": "center",
						"size": "1/3"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {
								"content": {
									"entityMap": {},
									"blocks": [
										{
											"key": "fgn2m",
											"text": "Single",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 6,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										}
									]
								}
							}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"hAlign": "center",
						"size": "1/3"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {
								"content": {
									"entityMap": {},
									"blocks": [
										{
											"key": "epv2v",
											"text": "Most Popular",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 12,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										}
									]
								}
							}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"hAlign": "center",
						"size": "1/3"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {
								"content": {
									"entityMap": {},
									"blocks": [
										{
											"key": "161r1",
											"text": "Ultimate",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 8,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										}
									]
								}
							}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"hAlign": "center",
						"size": "1/3"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {
								"transform": {}
							},
							"props": {
								"content": {
									"entityMap": {},
									"blocks": [
										{
											"key": "fgn2m",
											"text": "xxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "2a6g9",
											"text": "xxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "b99ch",
											"text": "xxxxxxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 11,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										},
										{
											"key": "7i07n",
											"text": "xxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "i2h6",
											"text": "xxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "akm5m",
											"text": "xxxxxxxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 12,
													"style": "UNDERLINE"
												}
											],
											"entityRanges": []
										},
										{
											"key": "a3lp3",
											"text": "xxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "8kv6",
											"text": "xxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "7360d",
											"text": "xxxxxxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 11,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										},
										{
											"key": "8u2bu",
											"text": "xxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "6iefj",
											"text": "xxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "9hua2",
											"text": "xxxxxxxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 12,
													"style": "UNDERLINE"
												}
											],
											"entityRanges": []
										},
										{
											"key": "1ciqe",
											"text": "xxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "fg6ba",
											"text": "xxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "6tn8c",
											"text": "xxxxxxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 11,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										},
										{
											"key": "11i8b",
											"text": "xxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "d9p8j",
											"text": "xxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "4aubv",
											"text": "xxxxxxxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 12,
													"style": "UNDERLINE"
												}
											],
											"entityRanges": []
										}
									]
								}
							}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"hAlign": "center",
						"size": "1/3"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {
								"transform": {}
							},
							"props": {
								"content": {
									"entityMap": {},
									"blocks": [
										{
											"key": "fgn2m",
											"text": "xxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "2a6g9",
											"text": "xxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "b99ch",
											"text": "xxxxxxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 11,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										},
										{
											"key": "7i07n",
											"text": "xxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "i2h6",
											"text": "xxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "akm5m",
											"text": "xxxxxxxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 12,
													"style": "UNDERLINE"
												}
											],
											"entityRanges": []
										},
										{
											"key": "a3lp3",
											"text": "xxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "8kv6",
											"text": "xxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "7360d",
											"text": "xxxxxxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 11,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										},
										{
											"key": "8u2bu",
											"text": "xxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "6iefj",
											"text": "xxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "9hua2",
											"text": "xxxxxxxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 12,
													"style": "UNDERLINE"
												}
											],
											"entityRanges": []
										},
										{
											"key": "1ciqe",
											"text": "xxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "fg6ba",
											"text": "xxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "6tn8c",
											"text": "xxxxxxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 11,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										},
										{
											"key": "11i8b",
											"text": "xxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "d9p8j",
											"text": "xxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "4aubv",
											"text": "xxxxxxxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 12,
													"style": "UNDERLINE"
												}
											],
											"entityRanges": []
										}
									]
								}
							}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"hAlign": "center",
						"size": "1/3"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {
								"transform": {}
							},
							"props": {
								"content": {
									"entityMap": {},
									"blocks": [
										{
											"key": "fgn2m",
											"text": "xxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "2a6g9",
											"text": "xxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "b99ch",
											"text": "xxxxxxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 11,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										},
										{
											"key": "7i07n",
											"text": "xxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "i2h6",
											"text": "xxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "akm5m",
											"text": "xxxxxxxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 12,
													"style": "UNDERLINE"
												}
											],
											"entityRanges": []
										},
										{
											"key": "a3lp3",
											"text": "xxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "8kv6",
											"text": "xxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "7360d",
											"text": "xxxxxxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 11,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										},
										{
											"key": "8u2bu",
											"text": "xxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "6iefj",
											"text": "xxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "9hua2",
											"text": "xxxxxxxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 12,
													"style": "UNDERLINE"
												}
											],
											"entityRanges": []
										},
										{
											"key": "1ciqe",
											"text": "xxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "fg6ba",
											"text": "xxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "6tn8c",
											"text": "xxxxxxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 11,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										},
										{
											"key": "11i8b",
											"text": "xxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "d9p8j",
											"text": "xxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										},
										{
											"key": "4aubv",
											"text": "xxxxxxxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 12,
													"style": "UNDERLINE"
												}
											],
											"entityRanges": []
										}
									]
								}
							}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"hAlign": "center",
						"size": "1/3"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {
								"content": {
									"entityMap": {},
									"blocks": [
										{
											"key": "fgn2m",
											"text": "$ xxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 5,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										}
									]
								}
							}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"hAlign": "center",
						"size": "1/3"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {
								"content": {
									"entityMap": {},
									"blocks": [
										{
											"key": "fgn2m",
											"text": "$ xxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 5,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										}
									]
								}
							}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"hAlign": "center",
						"size": "1/3"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {
								"content": {
									"entityMap": {},
									"blocks": [
										{
											"key": "fgn2m",
											"text": "$ xxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 5,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										}
									]
								}
							}
						}
					],
					"containers": [],
					"bindings": {}
				}
			],
			"bindings": {}
		},
		{
			"name": "Chat",
			"elementName": "Grid",
			"style": {},
			"props": {
				"gutter": "2px 20px 2px",
				"flexCells": false
			},
			"boxes": [],
			"containers": [
				{
					"name": "Copy Container",
					"elementName": "Cell",
					"style": {},
					"props": {
						"hAlign": "center",
						"size": "1/1",
						"background": {
							"color": {
								"color": "#ffffff",
								"hsv": {
									"h": 0,
									"s": 0,
									"v": 100
								},
								"alpha": 100
							},
							"filter": {}
						}
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {
								"content": {
									"entityMap": {},
									"blocks": [
										{
											"key": "4ida0",
											"text": "CHAT",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 4,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										}
									]
								}
							}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"hAlign": "center",
						"size": "1/5"
					},
					"boxes": [
						{
							"elementName": "Core.Icon",
							"props": {
								"icon": "MdPerson",
								"width": 60,
								"height": 60
							},
							"name": "Core.Icon",
							"style": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"size": "4/5"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {
								"content": {
									"entityMap": {},
									"blocks": [
										{
											"key": "3da8k",
											"text": "xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										}
									]
								}
							}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"size": "4/5"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {
								"content": {
									"entityMap": {},
									"blocks": [
										{
											"key": "3da8k",
											"text": "xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										}
									]
								}
							}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"hAlign": "center",
						"size": "1/5"
					},
					"boxes": [
						{
							"elementName": "Core.Icon",
							"props": {
								"icon": "MdPerson",
								"width": 60,
								"height": 60
							},
							"name": "Core.Icon",
							"style": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"hAlign": "center",
						"size": "1/5"
					},
					"boxes": [
						{
							"elementName": "Core.Icon",
							"props": {
								"icon": "MdPerson",
								"width": 60,
								"height": 60
							},
							"name": "Core.Icon",
							"style": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"size": "4/5"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {
								"content": {
									"entityMap": {},
									"blocks": [
										{
											"key": "3da8k",
											"text": "xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx xxxxx xxxxxxxxxx",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										}
									]
								}
							}
						}
					],
					"containers": [],
					"bindings": {}
				}
			],
			"bindings": {}
		},
		{
			"name": "Blog",
			"elementName": "Grid",
			"style": {},
			"props": {
				"gutter": "2px 2px 2px",
				"flexCells": false
			},
			"boxes": [],
			"containers": [
				{
					"name": "Copy Container",
					"elementName": "Cell",
					"style": {},
					"props": {
						"hAlign": "center",
						"size": "1/1",
						"background": {
							"color": {
								"color": "#ffffff",
								"hsv": {
									"h": 0,
									"s": 0,
									"v": 100
								},
								"alpha": 100
							},
							"filter": {}
						}
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {
								"content": {
									"entityMap": {},
									"blocks": [
										{
											"key": "em48q",
											"text": "BLOG",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 4,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										}
									]
								}
							}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"hAlign": "left",
						"background": {
							"color": {
								"color": "#ffffff",
								"hsv": {
									"h": 93,
									"s": 0,
									"v": 100
								},
								"alpha": 100
							},
							"filter": {}
						}
					},
					"boxes": [],
					"containers": [
						{
							"elementName": "Grid",
							"style": {},
							"containers": [
								{
									"elementName": "Cell",
									"style": {},
									"containers": [],
									"boxes": [
										{
											"elementName": "Core.Icon",
											"props": {
												"icon": "MdFace",
												"width": 60,
												"height": 60
											},
											"name": "Core.Icon",
											"style": {}
										}
									],
									"name": "Cell",
									"props": {
										"size": "1/5"
									},
									"bindings": {}
								},
								{
									"elementName": "Cell",
									"style": {},
									"containers": [],
									"boxes": [
										{
											"elementName": "Core.RichTextContent",
											"name": "Core.RichTextContent",
											"style": {
												"transform": {}
											},
											"props": {
												"content": {
													"entityMap": {},
													"blocks": [
														{
															"key": "fhtkd",
															"text": "xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx ",
															"type": "unstyled",
															"depth": 0,
															"inlineStyleRanges": [],
															"entityRanges": []
														}
													]
												}
											},
											"boxes": [
												{
													"elementName": "Core.Icon",
													"props": {
														"icon": "MdAllOut",
														"width": 60,
														"height": 60
													},
													"name": "Core.Icon",
													"style": {}
												}
											]
										}
									],
									"name": "Cell",
									"props": {
										"size": "2/3"
									},
									"bindings": {}
								},
								{
									"elementName": "Cell",
									"style": {},
									"containers": [],
									"boxes": [
										{
											"elementName": "Core.Icon",
											"props": {
												"icon": "MdFace",
												"width": 60,
												"height": 60
											},
											"name": "Core.Icon",
											"style": {}
										}
									],
									"name": "Copy Cell",
									"props": {
										"align": "top",
										"size": "1/5"
									},
									"bindings": {}
								},
								{
									"elementName": "Cell",
									"style": {},
									"containers": [],
									"boxes": [
										{
											"elementName": "Core.RichTextContent",
											"name": "Copy Core.RichTextContent",
											"style": {
												"top": 0
											},
											"props": {
												"content": {
													"entityMap": {},
													"blocks": [
														{
															"key": "fhtkd",
															"text": "xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx ",
															"type": "unstyled",
															"depth": 0,
															"inlineStyleRanges": [],
															"entityRanges": []
														}
													]
												}
											}
										}
									],
									"name": "Copy Cell",
									"props": {
										"size": "2/3"
									},
									"bindings": {}
								},
								{
									"elementName": "Cell",
									"style": {},
									"containers": [],
									"boxes": [
										{
											"elementName": "Core.Icon",
											"props": {
												"icon": "MdFace",
												"width": 60,
												"height": 60
											},
											"name": "Copy Core.Icon",
											"style": {
												"top": 0
											}
										}
									],
									"name": "Copy Cell",
									"props": {
										"align": "top",
										"size": "1/5"
									},
									"bindings": {}
								},
								{
									"elementName": "Cell",
									"style": {},
									"containers": [],
									"boxes": [
										{
											"elementName": "Core.RichTextContent",
											"name": "Copy Core.RichTextContent",
											"style": {
												"top": 0
											},
											"props": {
												"content": {
													"entityMap": {},
													"blocks": [
														{
															"key": "fhtkd",
															"text": "xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx ",
															"type": "unstyled",
															"depth": 0,
															"inlineStyleRanges": [],
															"entityRanges": []
														}
													]
												}
											}
										}
									],
									"name": "Copy Cell",
									"props": {
										"align": "top",
										"size": "2/3"
									},
									"bindings": {}
								}
							],
							"boxes": [],
							"name": "Grid",
							"props": {
								"align": "top",
								"gutter": "0px 20px",
								"flexCells": true
							},
							"bindings": {}
						}
					],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"size": "1/3"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {
								"content": {
									"entityMap": {},
									"blocks": [
										{
											"key": "30i04",
											"text": " xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx  xxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx  xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx xxxxxxxxxx  xxxxxxxxx xxxxxxxxxx ",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [],
											"entityRanges": []
										}
									]
								}
							},
							"bindings": {}
						}
					],
					"containers": [],
					"bindings": {}
				}
			],
			"bindings": {}
		},
		{
			"name": "2Column",
			"elementName": "Grid",
			"style": {},
			"props": {
				"align": "top",
				"hAlign": "center",
				"gutter": "2px 2px 2px",
				"flexCells": false
			},
			"boxes": [],
			"containers": [
				{
					"name": "Cell",
					"elementName": "Cell",
					"style": {},
					"props": {
						"hAlign": "center",
						"size": "1/1",
						"background": {
							"color": {
								"color": "#ffffff",
								"hsv": {
									"h": 0,
									"s": 0,
									"v": 100
								},
								"alpha": 100
							},
							"filter": {}
						}
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Copy Core.RichTextContent",
							"style": {
								"top": 0
							},
							"props": {
								"content": {
									"entityMap": {},
									"blocks": [
										{
											"key": "1ub67",
											"text": "2 COLUMN",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 8,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										}
									]
								}
							}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"align": "center",
						"hAlign": "center",
						"flex": false,
						"size": "1/2"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"hAlign": "center",
						"flex": false,
						"size": "1/2"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {}
						}
					],
					"containers": [],
					"bindings": {}
				}
			],
			"bindings": {}
		},
		{
			"name": "3Column",
			"elementName": "Grid",
			"style": {},
			"props": {
				"gutter": "2px 2px 2px",
				"flexCells": false
			},
			"boxes": [],
			"containers": [
				{
					"name": "Copy Container",
					"elementName": "Cell",
					"style": {},
					"props": {
						"hAlign": "center",
						"size": "1/1",
						"background": {
							"color": {
								"color": "#ffffff",
								"hsv": {
									"h": 0,
									"s": 0,
									"v": 100
								},
								"alpha": 100
							},
							"filter": {}
						}
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {
								"content": {
									"entityMap": {},
									"blocks": [
										{
											"key": "1ub67",
											"text": "3 COLUMN",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 8,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										}
									]
								}
							}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"hAlign": "center",
						"size": "1/3"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"hAlign": "center",
						"size": "1/3"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"hAlign": "center",
						"size": "1/3"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {}
						}
					],
					"containers": [],
					"bindings": {}
				}
			],
			"bindings": {}
		},
		{
			"name": "4Column",
			"elementName": "Grid",
			"style": {},
			"props": {
				"gutter": "2px 2px 2px",
				"flexCells": false
			},
			"boxes": [],
			"containers": [
				{
					"name": "Copy Container",
					"elementName": "Cell",
					"style": {},
					"props": {
						"hAlign": "center",
						"size": "1/1",
						"background": {
							"color": {
								"color": "#ffffff",
								"hsv": {
									"h": 0,
									"s": 0,
									"v": 100
								},
								"alpha": 100
							},
							"filter": {}
						}
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {
								"content": {
									"entityMap": {},
									"blocks": [
										{
											"key": "9vak2",
											"text": "4 COLUMN",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 8,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										}
									]
								}
							}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"hAlign": "center",
						"size": "1/4"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"hAlign": "center",
						"size": "1/4"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"hAlign": "center",
						"size": "1/4"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"hAlign": "center",
						"size": "1/4"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {}
						}
					],
					"containers": [],
					"bindings": {}
				}
			],
			"bindings": {}
		},
		{
			"name": "2Rows",
			"elementName": "Grid",
			"style": {},
			"props": {
				"gutter": "2px 2px 2px",
				"flexCells": false
			},
			"boxes": [],
			"containers": [
				{
					"name": "Copy Container",
					"elementName": "Cell",
					"style": {},
					"props": {
						"hAlign": "center",
						"size": "1/1",
						"background": {
							"color": {
								"color": "#ffffff",
								"hsv": {
									"h": 0,
									"s": 0,
									"v": 100
								},
								"alpha": 100
							},
							"filter": {}
						}
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {
								"content": {
									"entityMap": {},
									"blocks": [
										{
											"key": "4ida0",
											"text": "2 ROWS",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 6,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										}
									]
								}
							}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"hAlign": "left",
						"size": "1/1"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"size": "1/1"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {}
						}
					],
					"containers": [],
					"bindings": {}
				}
			],
			"bindings": {}
		},
		{
			"name": "3Rows",
			"elementName": "Grid",
			"style": {},
			"props": {
				"gutter": "2px 2px 2px",
				"flexCells": false
			},
			"boxes": [],
			"containers": [
				{
					"name": "Copy Container",
					"elementName": "Cell",
					"style": {},
					"props": {
						"hAlign": "center",
						"size": "1/1",
						"background": {
							"color": {
								"color": "#ffffff",
								"hsv": {
									"h": 0,
									"s": 0,
									"v": 100
								},
								"alpha": 100
							},
							"filter": {}
						}
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {
								"content": {
									"entityMap": {},
									"blocks": [
										{
											"key": "em48q",
											"text": "3 ROWS",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 6,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										}
									]
								}
							}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"size": "1/1"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"size": "1/1"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"size": "1/1"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {}
						}
					],
					"containers": [],
					"bindings": {}
				}
			],
			"bindings": {}
		},
		{
			"name": "4Rows",
			"elementName": "Grid",
			"style": {},
			"props": {
				"gutter": "2px 2px 2px",
				"flexCells": false
			},
			"boxes": [],
			"containers": [
				{
					"name": "Copy Container",
					"elementName": "Cell",
					"style": {},
					"props": {
						"hAlign": "center",
						"size": "1/1",
						"background": {
							"color": {
								"color": "#ffffff",
								"hsv": {
									"h": 0,
									"s": 0,
									"v": 100
								},
								"alpha": 100
							},
							"filter": {}
						}
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {
								"content": {
									"entityMap": {},
									"blocks": [
										{
											"key": "em48q",
											"text": "4 ROWS",
											"type": "unstyled",
											"depth": 0,
											"inlineStyleRanges": [
												{
													"offset": 0,
													"length": 6,
													"style": "BOLD"
												}
											],
											"entityRanges": []
										}
									]
								}
							}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"size": "1/1"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"size": "1/1"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"size": "1/1"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {}
						}
					],
					"containers": [],
					"bindings": {}
				},
				{
					"name": "Copy Cell",
					"elementName": "Cell",
					"style": {
						"position": "relative"
					},
					"props": {
						"size": "1/1"
					},
					"boxes": [
						{
							"elementName": "Core.RichTextContent",
							"name": "Core.RichTextContent",
							"style": {},
							"props": {}
						}
					],
					"containers": [],
					"bindings": {}
				}
			],
			"bindings": {}
		}
	],
	"props": {
		"pageOptions": {
			"width": 559,
			"height": 794,
			"doublePage": true,
			"margin": {
				"right": 10,
				"left": 10,
				"top": 10,
				"bottom": 10
			}
		},
		"context": {
			"styles": {
				"Cell": {
					"background": {
						"color": {
							"color": "#fcffd4",
							"hsv": {
								"h": 63.641759797501116,
								"s": 17,
								"v": 100
							},
							"alpha": 100
						},
						"filter": {}
					}
				},
				"Core.RichTextContent": {
					"font": {
						"fontFamily": "Indie Flower",
						"fontSize": 23,
						"bold": false
					}
				}
			}
		}
	},
	"bindings": {}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/toolbox/templates/UITiles.json
 ** module id = 972
 ** module chunks = 0
 **/